<template>
	<div class="content">
		<div class="center">
			<div class="detail-box">
				<div class="device-box flex-row">
					<div class="device-img">
						<img :src="$imgUrl + info.pictureUrl" />
					</div>
					<div class="device-info">
						<p class="name">{{info.title}}</p>
						<div class="price-box flex-row">
							<span>价格</span>
							<span class="price">￥{{info.emergencyPrice}} /天</span>
						</div>
						<p class="tips">
							*价格说明<br>
							在勘查现场后，相关费用可能发生变化。
						</p>
						<div class="info">
							<div class="title">
								<p>设备信息</p>
							</div>
							<div class="info-intro flex-row">
								<div class="item"> <label>提供人姓名</label> <span>{{info.name || '未知'}}</span> </div>
								<div class="item"> <label>设备类型</label> <span>{{info.typeName}}</span> </div>
								<div class="item"> <label>设备容量</label> <span>{{info.volume}}</span> </div>
								<div class="item"> <label>设备地点</label>
									<span>{{(info.provinceName + info.cityName + info.countyName) || '未知'}}</span>
								</div>
								<div class="item"> <label>输出电压</label> <span>{{info.voltage}}</span> </div>
							</div>
						</div>
					</div>
					<div class="btns">
						<button class="apply" @click="openCustomerServer">在线留言</button>
						<br>
						<button class="service" @click="customerServer">联系客服</button>
					</div>
				</div>
			</div>

			<div class="order">
				<div class="order-info">
					<div class="top flex-row">
						<div class="item address-box">
						<p class="tit1">*工程名称</p>
						<div class="address flex-row" style="margin-bottom: 70px">
							<el-input v-model="projectname"
												placeholder="请填写工程名称"
												>

							</el-input>
						</div>
						</div>
						<div class="item address-box">
							<p class="tit1">地址信息</p>
							<div class="address flex-row">
								<el-select v-model="addressVal" placeholder="请选择地址" size="medium" style="width: 300px;">
									<el-option v-for="(item, index) in addressList" :key="item.id"
										:label="item.provinceName + '-' + item.cityName + '-' + item.countyName + ' ' + item.address"
										:value="item.provinceName + item.cityName + item.countyName + item.address">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="item service-item">
							<p class="tit2">服务天数</p>
							<div class=" flex-row" style="padding-top: 15px;">
								<el-input placeholder="请输入天数" v-model="form.advanceDate" style="width: 100%;">
									<template slot="prepend">时长</template>
									<template slot="append">天</template>
								</el-input>
							</div>
						</div>
						<div class="item date-item">
							<div class="cont flex-row">
								<p>*开始时间：</p>
								<el-date-picker class="date" v-model="form.startTime" value-format="yyyy-MM-dd"
									type="date" placeholder="选择日期">
								</el-date-picker>
							</div>
							<p class="tips">*结束时间为次日开始时间的日期</p>
						</div>
					</div>
					<div class="pre-pay">
						<p class="tit3">油费预付</p>
						<div class="cont flex-row">
							<span>油费价格：</span>
							<span>￥{{info.oilCost}}</span>
							<span>/小时</span>
						</div>
						<p class="tips">*设备油费单独收费，不包含在设备租赁费中，您需要预支付每天10小时的油费价格，多退少补。</p>
					</div>
				</div>
				<div class="bot flex-row">
					<button class="apply" @click="submit(1)">提交申请</button>
<!--					<button class="saveOrder" @click="">生成紧急订单</button>-->
					<button class="saveOrder" @click="submit(0)">保存订单</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import RelatedCompany from '@/components/ordinary/relatedCompany.vue'
	import {
		equipmentDetailApi,
		addOrderApi,
		adderssList
	} from '../../http/api/ordinary.js'
	export default {
		components: {
			RelatedCompany
		},
		data() {
			return {
				projectname:null,
				form: {
					orderSatus: null,
					userAddress: '',
					startTime: null,
					orderType: 1,
					businessId: null,
					equipmentId: null,
					advanceDate: 1
				},
				info: {},
				addressList: [],
				addressVal: ""
			}
		},
		created() {
			this.getDetail()
			this.getAddress();
		},
		methods: {
			getAddress() {
				adderssList({}).then(res => {
					this.addressList = res.rows;
				});
			},
			customerServer() {
				this.$router.push({
					path: '/service'
				})
			},
			openCustomerServer() {
				this.$router.push({
					path: '/service',
					query: {
						contactType: 1,
						contactId: this.info.customerId
					}
				})
			},
			getDetail() {
				equipmentDetailApi({
					id: this.$route.query.id
				}).then(res => {
					this.info = res
				})
			},
			submit(type) {
				if (this.projectname == null) {
					return this.$message('请填写工程名称')
				}
				if (this.form.startTime == null) {
					return this.$message('请选择开始时间')
				}
				this.$confirm(`您确认要${type == 1 ? '申请' : '保存'}当前订单吗`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.form.userAddress = this.addressVal,
							this.form.projectname = this.projectname,
						this.form.equipmentId = this.info.id
					this.form.businessId = this.info.customerId
					this.form.orderSatus = type
					this.form.advance = this.info.emergencyPrice * this.form.advanceDate
					this.form.advanceFuel = this.info.oilCost * this.form.advanceDate * 10
					addOrderApi(this.form).then(res => {
						this.$message({
							type: 'success',
							message: '创建成功'
						});
						this.$router.push({
							path: '/personalCenter/orderPower'
						})
					})

				})

			},
		}
	}
</script>

<style scoped lang="less">
	.content {
		font-size: .14rem;
		background: #F5F5F5;

		.center {
			width: 16.88rem;
			margin: 0 auto;
			padding: 0.2rem 0;

			button {
				outline: none;
				cursor: pointer;
			}
		}

		.detail-box {
			background: #FFFFFF;
			border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
			padding: .28rem .3rem .33rem;

			.device-box {
				.device-img {
					width: 2.96rem;
					height: 2.96rem;
					border-radius: 0.06rem;
					margin-right: .2rem;

					img {
						width: 100%;
						height: 100%;
						border-radius: 0.06rem;
					}
				}

				.device-info {
					flex: 1;
					width: 6.61rem;

					.name {
						font-size: .2rem;
						color: #333333;
						line-height: .3rem;
						font-weight: 500;
					}

					.price-box {
						margin-top: .22rem;
						font-size: .14rem;
						color: #000000;
						line-height: .2rem;
						align-items: center;
						position: relative;

						.price {
							color: #FF4141;
							margin-left: .1rem;
						}
					}

					.tips {
						font-size: .13rem;
						color: #8F8F8F;
						line-height: .33rem;
						margin-top: .1rem;
					}

					.info {
						width: 100%;
						border-radius: .06rem;
						opacity: 1;
						border: 1px solid #F2F2F2;
						margin-top: .16rem;

						.title {
							height: .44rem;
							background: #FFF3EC;
							padding: 0 .24rem;

							p {
								font-size: .16rem;
								color: #000000;
								line-height: .44rem;
								position: relative;

								&::after {
									content: '';
									width: .04rem;
									height: .14rem;
									background: #FF5400;
									position: absolute;
									top: .14rem;
									left: -0.1rem;
								}
							}
						}

						.info-intro {
							flex-wrap: wrap;
							padding: .1rem 0;
							background-color: #FFFDFC;

							.item {
								width: calc(50% - .4rem);
								line-height: 0;
								padding: .15rem .2rem;

								label {
									display: inline-block;
									min-width: .9rem;
									font-size: .14rem;
									line-height: .24rem;
									color: #AAAAAA;
									margin-right: .2rem;
									text-align: right;
								}

								span {
									font-size: .14rem;
									line-height: .24rem;
									color: #333333;
								}
							}
						}
					}
				}

				.btns {
					flex: 1;
					text-align: right;
					padding-right: .22rem;

					.apply {
						width: 1.07rem;
						height: .42rem;
						background: #FA6600;
						border-radius: .06rem;
						font-size: .14rem;
						color: #FFFFFF;
						line-height: .42rem;
						text-align: center;
						border: none;
					}

					.service {
						width: 1.07rem;
						height: .42rem;
						background: #FFFFFF;
						border-radius: .06rem;
						border: 1px solid #FA6600;
						font-size: .14rem;
						color: #FA6600;
						line-height: .42rem;
						text-align: center;
						margin-top: .2rem;
					}
				}
			}

		}

		.order {
			margin-top: .1rem;
			background: #FFFFFF;
			border-radius: .06rem;
			padding: .3rem 0 0;

			.order-info {
				padding: 0 .3rem;

				.top {
					.address-box {
						margin-right: 1.7rem;

						.tit1 {
							font-size: .16rem;
							color: #000000;
							line-height: .2rem;
						}

						.address {
							padding-top: .15rem;
							position: relative;

							.address-info {
								flex: 1;
								padding-right: 1.1rem;

								p {
									font-size: .14rem;
									color: #333333;
									line-height: 1.2;
								}

								p:nth-of-type(2) {
									margin-top: .1rem;
									font-size: .14rem;
									color: #5F5F5F;
									line-height: 1.2;
								}
							}

							button {
								width: .93rem;
								height: .3rem;
								background: #FF5400;
								border-radius: .03rem;
								font-size: .12rem;
								color: #FFFFFF;
								line-height: .3rem;
								border: none;
								position: absolute;
								right: .17rem;
								bottom: .18rem;
							}
						}
					}

					.service-item {
						margin-right: .69rem;

						.tit2 {
							font-size: .16rem;
							color: #000000;
							line-height: .2rem;
						}

						.cont {
							margin-top: .12rem;
							width: 3.33rem;
							height: .43rem;
							background: #F5F5F5;
							border-radius: .06rem;
							justify-content: space-between;
							padding: 0 .14rem;

							span {
								font-size: .14rem;
								line-height: .43rem;
							}
						}
					}

					.date-item {
						.cont {
							margin-top: .32rem;
							width: 3.33rem;
							height: .43rem;
							background: #F5F5F5;
							border-radius: .06rem;
							justify-content: space-between;
							padding: 0 .14rem;
							align-items: center;

							p {
								white-space: nowrap;
								line-height: .43rem;
							}

							.date {
								border-radius: .06rem;

								/deep/.el-input {
									flex: 1;
								}

								/deep/.el-input__inner {
									width: 100%;
									height: .43rem;
									background: #F5F5F5;
									padding-left: 0;
									font-size: .14rem;
									color: #000000;
									border: none;
									text-align: center;
								}

								/deep/.el-input__prefix {
									left: unset;
									right: 0;
								}

								/deep/.el-input__icon {
									line-height: .43rem;
								}
							}
						}
					}
				}

				.pre-pay {
					margin-top: .55rem;

					.tit3 {
						font-size: .16rem;
						color: #000000;
						line-height: .2rem;
					}

					.cont {
						margin-top: .12rem;
						width: 3.33rem;
						height: .43rem;
						background: #F5F5F5;
						border-radius: .06rem;
						justify-content: space-between;
						padding: 0 .14rem;

						span {
							font-size: .14rem;
							line-height: .43rem;
						}
					}
				}

				.tips {
					font-size: .13rem;
					color: #FF7575;
					margin-top: .1rem;
					line-height: .2rem;
				}
			}

			.bot {
				margin-top: .4rem;
				width: calc(100% - .6rem);
				padding: .22rem .3rem .22rem;
				justify-content: flex-end;

				.apply {
					width: 1.38rem;
					height: .4rem;
					background: #686868;
					border: 1px solid #686868;
					border-radius: .09rem;
					font-size: .14rem;
					color: #FFFFFF;
					line-height: .4rem;
					text-align: center;
					margin-left: .35rem;
				}

				.saveOrder {
					width: 1.38rem;
					height: .4rem;
					border: 1px solid #686868;
					border-radius: .09rem;
					font-size: .14rem;
					color: #686868;
					line-height: .4rem;
					text-align: center;
					margin-left: .32rem;
				}
			}
		}
	}
</style>
